<template>
  <div id="lucky-winner-reward-list">
    <b-card no-body class="p-2 container-card mb-1">
      <b-row>
        <b-col cols="12">
          <div>
            <div class="d-flex justify-content-end mb-1">
              <add-button
                :btn-label="'Reward'"
                @click.native="
                  $router.push(
                    `/lucky-winner/campaign/${campaignId}/round/${roundId}/reward/create`
                  )
                "
              />
            </div>
            <div class="d-flex flex-wrap justify-content-end">
              <div class="mr-1 ml-1 mb-1">
                <v-select
                  id="reward-type-status"
                  class="v-select-filter bg-document-list bg-dropdown"
                  :class="status ? 'v-select-filter-selected' : null"
                  placeholder="Status"
                  :options="statusOption"
                  @input="(option) => onSelectFilter('status', option)"
                />
              </div>

              <div class="search-container mb-1">
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                ref="rewardTable"
                :fields="fields"
                :items="rewardListTable.payload"
                responsive
                bordered
                borderless
                show-empty
                class="default-static-table"
                select-mode="single"
                selectable
                @row-selected="onRewardSelected"
              >
                <template #head(image_url)="data">
                  <div class="text-center">
                    {{ data.field.label }}
                  </div>
                </template>
                <template #cell(image_url)="data">
                  <div class="d-flex justify-content-center">
                    <img
                      :src="data.item.image_url || DefaultImg"
                      class="image-column"
                    />
                  </div>
                </template>
                <template #cell(status)="data">
                  <b-form-checkbox
                    field-value="true"
                    class="custom-control-success custom-toggle"
                    name="check-button"
                    switch
                    :checked="data.item.status == 1 ? true : false"
                    @change="onToggleStatus($event, data.item)"
                  >
                    <span class="switch-icon-left toggle-text">{{
                      'Active'
                    }}</span>
                    <span class="switch-icon-right toggle-text">{{
                      'Inactive'
                    }}</span>
                  </b-form-checkbox>
                </template>
                <template #cell(actions)="data">
                  <div class="cursor-pointer">
                    <div class="d-flex justify-content-center">
                      <b-button
                        v-b-tooltip.hover
                        title="Edit"
                        variant="secondary"
                        class="default-btn-action mr-2"
                        @click="
                          $router.push(
                            `/lucky-winner/campaign/${campaignId}/round/${roundId}/reward/info/${data.item.seq}`
                          )
                        "
                      >
                        <edit-icon
                          class="default-btn-action-svg iconEdit-btn"
                        />
                      </b-button>
                    </div>
                  </div>
                </template>
                <template #row-details="row">
                  <winner-list></winner-list>
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue"

import DefaultImg from '@/assets/images/icons/no-img-square.jpg';
import EditIcon from "@/@core/components/svg/common/Edit.vue"
import DetailIcon from "@/@core/components/svg/common/IconDetail2.vue"
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue"
import Search from "@/views/components/search/Search.vue"
import vSelect from "vue-select"

import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue"
import useRewardList from "./hooks/useRewardList"

import WinnerList from "./components/WinnerList.vue"

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    Search,
    vSelect,
    PaginationWithReorder,
    EditIcon,
    DetailIcon,
    WinnerList,
  },

  setup() {
    const {
      campaignId,
      roundId,
      rewardTable,
      fields,
      loading,
      statusOption,
      status,
      rewardListTable,
      pagination,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      onRewardSelected,
      onToggleStatus,
    } = useRewardList()

    return {
      campaignId,
      roundId,
      rewardTable,
      fields,
      loading,
      statusOption,
      status,
      rewardListTable,
      pagination,
      onPageChange,
      onFilterEntity,
      onSelectFilter,
      onSetValueSearch,
      onRewardSelected,
      onToggleStatus,
      DefaultImg
    }
  },
}
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/status.css";

.width-size {
  width: 1.6rem;
}

.btn-action,
.btn-action:active {
  border: none;
  background: transparent !important;
  padding: 0;
}

.btn-action-svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s;
}

.btn-action-svg.active {
  transform: rotate(180deg);
}

.btn-group-action-svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s;
}

.btn-group-action-svg.active {
  transform: rotate(180deg);
}
</style>
